import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StakingPage } from './staking';

@NgModule({
  declarations: [
    StakingPage,
  ],
  imports: [
    IonicPageModule.forChild(StakingPage),
  ],
})
export class StakingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/staking/staking.module.ts